import { CategoryView } from '../types/entity-types';

type GetUniqueLevel1CategoriesArgs = {
  categories: CategoryView[];
  level: 'level1' | 'level2';
};

/**
 * Extracts unique category values from an array of CategoryView objects based on the specified level
 *
 * @param categories - Array of CategoryView objects containing level1 and level2 properties
 * @param level - The category level to extract unique values from ('level1' or 'level2')
 * @returns Array of unique category strings for the specified level
 */
export const getUniqueLevelCategories = ({ categories, level }: GetUniqueLevel1CategoriesArgs) => {
  return Array.from(new Set(categories.map((category) => category[level])));
};
